// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"AQ-z","categoryName":"BQ-z","categoryNameSearchHeader":"CQ-z","categoryContent":"DQ-z","bottomAligned":"EQ-z","image":"FQ-z","imageNoBackground":"GQ-z"};